import React, {useState} from 'react';


export default function HeaderInput({text, id, type, dropdown, children, fontSize, value, name, validate, result, funcResult, fieldInDrop}){
    if (dropdown){
        return <FieldDropdown  key={id} text={text} id={id} dropdown={dropdown} children={children} value={value} name={name} validate={validate} result={result} funcResult={funcResult}/>
    } else {
        return <Field key={id} type={type} text={text} id={id} fontSize={fontSize} value={value} name={name} validate={validate} fieldInDrop={fieldInDrop}/>
    }
   
}


export function Field({id, allId, width, text, button, view, fontSize, value, name, validate, fieldInDrop, type}){

    let v = validate?.includes(name);

    const stylesBlock = {
        width: width ? width : 'auto',
        fontSize: fontSize ? fontSize : '16px',
    }

    const stylesInput = {
        boxShadow: v ? '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)' : '',
        border: v ? '1px solid red' : ''
    }

    return (
        <div style={stylesBlock} className={"max-[600px]:col-end-4 max-[600px]:col-start-1"}>                   
            <div className={(fieldInDrop ? 'field-in-drop' : '') + " max-[600px]:flex max-[600px]:justify-between"}>
                <label className="pb-2 block text-[15px]" htmlFor={'field-'+id}>{text}</label>
                <input style={stylesInput} type={type ? type : 'text'} id={'field-'+id} name={name} className="
                        mt-0
                        block
                        w-full
                        pl-4
                        px-0.5
                        border-gray-200
                        focus:ring-0 focus:shadow-md focus:border-[#f4dd3a]
                        max-[600px]:h-[40px]
                        max-[600px]:w-[90px]
                    "
                    onInput={(e) => value(e.target)}
                    />
            </div>
            {button ? <button className="bg-[#e52424ed] hover:bg-[#ff0000] active:bg-[#d89999] transition duration-200 text-[#fff] p-2 rounded flex mb-6 mr-[auto] ml-[auto] mt-4" onClick={() => view(allId, true)}>Удалить</button>: ''}    
        </div>
    );
}

export function FieldDropdown({id,text, dropdown, children, name, value, validate, result, funcResult}){
    const [drop, setDrop] = useState(false);

    function select(e){
        const textSearch = ['есть', 'другие'];
        textSearch.includes(e.target.selectedOptions[0].innerText.toLowerCase().trim()) ? setDrop(true) : setDrop(false)
    }

    return (
        <div className={`select-block col-start-1 col-end-3 max-[600px]:col-end-4 ${name}`}>
            <label htmlFor={'field-'+id} className="flex flex-wrap">
                <p className="text-[15px] select-block--title pb-2 basis-9/12 max-[600px]:basis-8/12">{text}</p>
                <select className="basis-3/12 max-[600px]:basis-4/12 block w-full mt-1 focus:shadow-md focus:border-[#f4dd3a]" id={'field-'+id} name={name} onInput={(e) => {value(e.target); funcResult({e, children, drop})}} onChange={select}>
                    {dropdown.map( (elem,index) => <option key={index}>{elem}</option> )}
                </select>
                <div className={drop ? "pt-5 w-full" : ''}>
                    {drop ? children.map( (el,index) => <HeaderInput key={el.idChild ? el.idChild : index} fieldInDrop={true} text={el.text} id={el.idChild} dropdown={el.dropdown} children={el.children} name={el.name} value={value} validate={validate} funcResult={funcResult}/>) : ''}
                </div>
            </label>
        </div>
    );
}
